<div
  [class.desktop]="(isDesktop$ | async) !== false"
  [class.mobile]="(isDesktop$ | async) === false"
>
  <router-outlet></router-outlet>
</div>
